<template>
    <div class="container bottom">
        <link href="/static/css/cabinet/style.css" rel="stylesheet" />
        <div class="row">
            <div class="silca col-md-120">
                <router-link style="font-size: 16px;" class="previous" to="/cabinet/">← назад</router-link> | <b>История бонусного счета</b>
            </div>
            <div class="col-md-120 bonusu">
                <div class="row">
                    <div class="col-md-120">
                        <div class="thumbnail bonus">
                            <div id="bonus">
                                <table  class="accia_table table_bonus">
                                    <tr class="table_bonus_perv">
                                        <th><b>Дата</b></th>
                                        <th><b>Описание</b></th>
                                        <th><b>Статус</b></th>
                                        <th><b>Количество</b></th>
                                    </tr>
                                    <tr v-for="h in history" :key="h.id">
                                        <td>{{h.date}}</td>
                                        <td>{{h.text}}</td>
                                        <td>{{h.status}}</td>
                                        <td>{{h.price}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'history',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      history: []
    }
  },
  mounted () {
    axios.get('https://crm.v-avtoservice.com/list/get-history-bonus?uid=' + this.user.uid).then(response => {
      this.history = response.data
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/history.vue